export default __webpack_public_path__ + "assets/icon-mixed_forest.svg";